<template>
  <div class="sh-products">
    <h3>Товары</h3>
    <ul class="uk-child-width-1-3@s uk-child-width-1-4@m uk-grid-match uk-flex-center" uk-grid v-if="items">
      <li v-for="item in items" :key="item.id">
        <div class="sh-products__item">
          <div class="sh-products__image" uk-lightbox v-if="item.image">
            <a :href="item.image.path"><img :src="item.image.path" alt=""></a>
          </div>
          <div class="sh-products__title">{{ item.title }}</div>
          <div class="sh-products__desc">{{ item.intro }}</div>
          <div class="sh-products__price">Цена: <strong>{{ item.price }}</strong> коинов</div>
          <div class="sh-products__button"><a href="#" @click.prevent="addToCart(item)">Добавить в корзину</a></div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: "products",
  inject: ['http'],
  data() {
    return {
      items: ''
    }
  },
  computed:{
    ...mapGetters({
      user: 'user'
    })
  },
  methods: {
    async getProducts() {
      this.items = await this.http.post('onGetProducts').then(res => res.data);
    },
    async addToCart(item){
      let data = {
          'user_id': this.user.id,
          'item': item
      }
      let res = await this.http.post('onAddToCart', data).then(res => res.data);
      let val = {
        'param': 'property',
        'value': res
      }
      this.$store.commit('updateUserParam', val);
      UIkit.scroll('.headline2').scrollTo('.sh_order');
    }
  },
  mounted() {
    this.getProducts();
  }
}
</script>